import type { TrackPublication } from "livekit-client";
import { createSignal } from "solid-js";

// Weak keys retain preferences across view remounts without retaining departed shares.
// Owners are renderers of this receiver's publication, never other participants.
const preferences = new WeakMap<
  TrackPublication,
  ReturnType<typeof createPreferences>
>();
function createPreferences() {
  const [quality, setQuality] = createSignal("auto");
  return { quality, setQuality, owners: new Set<HTMLVideoElement>() };
}
export function screenSharePreferences(publication: TrackPublication) {
  let state = preferences.get(publication);
  if (!state) {
    state = createPreferences();
    preferences.set(publication, state);
  }
  return state;
}
